module.exports = __webpack_public_path__ + "img/england-logo-icon.1b6db96d.png";